module.exports = __webpack_public_path__ + "img/icon_main_market.210426e7.svg";